import React from "react";

import Drawer from "antd/es/drawer";
import { useIntl } from "react-intl";

import { EntityTypesSupportedColumnSelection } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import ColumnModel from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";

import ColumnVisibility from "../../types/viewModel/ColumnVisibility";
import ColumnSelector from "../input/ColumnSelector/ColumnSelector";

import ColumnsMenu from "./ColumnsMenu";
import styles from "./SelectColumnsPane.module.scss";

interface Props {
  columns: ColumnModel<IField>;
  entityType: EntityTypesSupportedColumnSelection;
  fieldFilter?: (field: IField) => boolean;
  fixedFields?: IField[];
  onHide: () => void;
  onUpdate: (visibilities: ColumnVisibility[]) => void;
  showCategories?: boolean;
  visible: boolean;
}

const ColumnPane: React.FC<Props> = ({
  columns,
  entityType,
  fieldFilter,
  fixedFields,
  onHide,
  onUpdate,
  showCategories = true,
  visible,
}) => {
  const intl = useIntl();

  return (
    <Drawer
      className={styles.container}
      closable
      onClose={onHide}
      placement="right"
      title={
        <div className={styles.title}>
          <ColumnsMenu columns={columns} entityType={entityType} />
          {intl.formatMessage({
            id: "component.selectColumnsPane.title",
            defaultMessage: "Select Columns",
            description: "Title on select columns pane",
          })}
        </div>
      }
      visible={visible}
    >
      <ColumnSelector
        columns={columns}
        entityType={entityType}
        fieldFilter={fieldFilter}
        fixedFields={fixedFields}
        onUpdate={onUpdate}
        showCategories={showCategories}
      />
    </Drawer>
  );
};

export default ColumnPane;
